import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { IReceiver } from "dto/IPackage";
import Avatar from "components/Avatar";
import CloseIcon from "assets/icons/close.svg?react";
import { useTranslation } from "react-i18next";

const Receiver = ({ receiver }: { receiver: IReceiver }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.box}>
      <div className={styles.left}>
        <Avatar className={styles.avatar} name={receiver.Name} size="small" />
        <div className={styles.data}>
          <div className={styles.name}>{receiver.Name}</div>
          <div className={styles.address}>{receiver.Email}</div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.status}>{t("statuses.inProgress")}</div>
      </div>
    </div>
  );
};

const MultiPackageModal: FC<Props> = ({ pack, toggle }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.modal}>
      <div className={styles.header}>
        {t("packages.multiPackage")}
        <CloseIcon onClick={toggle} className={styles.closeIcon} />
      </div>
      <div className={styles.body}>
        {pack.Receivers.map((r) => (
          <Receiver receiver={r} />
        ))}
      </div>
    </div>
  );
};

export default MultiPackageModal;
